<template>
    <div>
        <!-- <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#features" data-bs-target="#clOne" aria-controls="clOne" to="" aria-expanded="false"><h4 class="property_block_title">Detail & Features</h4></router-link>
            </div>
            <div id="clOne" class="panel-collapse collapse show" aria-labelledby="clOne">
                <div class="block-body">
                    <ul class="deatil_features">
                        <li v-for="(item, index) in feature" :key="index"><strong>{{item.title}}</strong>{{item.subtitle}}</li>
                    </ul>
                </div>
            </div>
        </div> -->
<!--                         
        <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#dsrp" data-bs-target="#clTwo" aria-controls="clTwo" to="" aria-expanded="true"><h4 class="property_block_title">{{$t('Description')}}</h4></router-link>
            </div>
            <div id="clTwo" class="panel-collapse collapse show">
                <div class="block-body">
                    <p>{{props.item?.about}}</p>
                </div>
            </div>
        </div> -->
                        
        <!-- <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#amen"  data-bs-target="#clThree" aria-controls="clThree" to="" aria-expanded="true"><h4 class="property_block_title">Ameneties</h4></router-link>
            </div>
            <div id="clThree" class="panel-collapse collapse show">
                <div class="block-body">
                    <ul class="avl-features third color">
                        <li v-for="(item, index) in ameneties" :key="index">{{item}}</li>
                    </ul>
                </div>
            </div>
        </div> -->                      
        <!-- <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#floor"  data-bs-target="#clFive" aria-controls="clFive" to="" aria-expanded="true" class="collapsed"><h4 class="property_block_title">Floor Plan</h4></router-link>
            </div>
            <div id="clFive" class="panel-collapse collapse">
                <div class="block-body">
                    <div class="accordion" id="floor-option">
                        <div class="card">
                            <div class="card-header" id="firstFloor">
                                <h2 class="mb-0">
                                    <button type="button" class="btn btn-link" data-bs-toggle="collapse" data-bs-target="#firstfloor" aria-controls="firstfloor">First Floor<span>740 sq ft</span></button>									
                                </h2>
                            </div>
                            <div id="firstfloor" class="collapse" aria-labelledby="firstFloor" data-parent="#floor-option">
                                <div class="card-body">
                                    <img :src="floor" class="img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="seconfFloor">
                                <h2 class="mb-0">
                                    <button type="button" class="btn btn-link collapsed" data-bs-toggle="collapse" data-bs-target="#secondfloor" aria-controls="secondfloor">Second Floor<span>710 sq ft</span></button>
                                </h2>
                            </div>
                            <div id="secondfloor" class="collapse" aria-labelledby="seconfFloor" data-parent="#floor-option">
                                <div class="card-body">
                                    <img :src="floor" class="img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="third-garage">
                                <h2 class="mb-0">
                                    <button type="button" class="btn btn-link collapsed" data-bs-toggle="collapse" data-bs-target="#garages" aria-controls="garages">Garage<span>520 sq ft</span></button>                     
                                </h2>
                            </div>
                            <div id="garages" class="collapse" aria-labelledby="third-garage" data-parent="#floor-option">
                                <div class="card-body">
                                    <img :src="floor" class="img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#cinf"  data-bs-target="#cinf" aria-controls="clOne" to="" aria-expanded="true" class="collapsed"><h4 class="property_block_title">{{$t('Contact Info')}}</h4></router-link>
            </div>
            <div id="cinf" class="panel-collapse collapse">
                <div class="block-body">
                    <p> {{ $t("Email") }}:{{props.item?.email}}</p>
                    <p>
                        {{ $t("Phone") }}:
                        <a :href="`tel:${props.item?.phone}`" dir="ltr">{{ props.item?.phone }}</a>
                    </p>
                </div>
            </div>
        </div>                        
        <div class="property_block_wrap style-2">
            <div class="property_block_wrap style-2">
                <div class="property_block_wrap_header">
                <router-link 
                    data-bs-toggle="collapse" 
                    data-parent="#loca"  
                    data-bs-target="#clSix" 
                    aria-controls="clSix" 
                    to="" 
                    aria-expanded="true" 
                    class="collapsed"
                >
                    <h4 class="property_block_title">{{ $t('Location') }}</h4>
                </router-link>
                </div>

                <div id="clSix" class="panel-collapse collapse">
                <div class="block-body">
                    <div class="map-container">
                    <iframe 
                        v-if="mapUrl"
                        :src="mapUrl" 
                        width="100%" 
                        height="450" 
                        style="border:0;" 
                        allowfullscreen 
                        loading="lazy" 
                        referrerpolicy="no-referrer-when-downgrade">
                    </iframe>
                    <p v-else>{{$t('No location available')}}</p>
                    </div>
                </div>
                </div>
            </div>
        </div>
                        
        <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#clSev"  data-bs-target="#clSev" aria-controls="clOne" to="" aria-expanded="true" class="collapsed"><h4 class="property_block_title">{{$t('Business Gallery')}}</h4></router-link>
            </div>
            <div id="clSev" class="panel-collapse collapse">
                <div class="block-body">
                    <ul class="list-gallery-inline">
                        <li v-for="(image, index) in props.item.gallery" :key="index">
                            <router-link to="" class="mfp-gallery"><img :src="image.image_url" class="img-fluid mx-auto" alt="" /></router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>        
        <!-- <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#vid"  data-bs-target="#clFour" aria-controls="clFour" to="" aria-expanded="true" class="collapsed"><h4 class="property_block_title">{{$t('video')}}</h4></router-link>
            </div>
            <div id="clFour" class="panel-collapse collapse">
                <div class="block-body">
                    <div class="property_video">
                        <div class="thumb">
                            <img class="pro_img img-fluid w100" :src="pl6" alt="7.jpg">
                            <div class="overlay_icon">
                                <div class="bb-video-box">
                                    <div class="bb-video-box-inner">
                                        <div class="bb-video-box-innerup">
                                            <a href="https://www.youtube.com/watch?v=A8EI6JaFbv4" data-bs-toggle="modal" data-bs-target="#popup-video" class="text-primary"><i class="fa-solid fa-play"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- <div class="rating-overview">
            <div class="rating-overview-box">
                <span class="rating-overview-box-total">4.2</span>
                <span class="rating-overview-box-percent">out of 5.0</span>
                <div class="star-rating" data-rating="5">
                    <i class="fas fa-star fs-xs mx-1"></i><i class="fas fa-star fs-xs mx-1"></i><i class="fas fa-star fs-xs mx-1"></i><i class="fas fa-star fs-xs mx-1"></i><i class="fas fa-star fs-xs mx-1"></i>
                </div>
            </div>

            <div class="rating-bars">
                <div class="rating-bars-item">
                    <span class="rating-bars-name">{{$t('Quality of execution')}}</span>
                    <span class="rating-bars-inner">
                        <span class="rating-bars-rating high" data-rating="4.7">
                            <span class="rating-bars-rating-inner" style="width: 85%;"></span>
                        </span>
                        <strong>4.7</strong>
                    </span>
                </div>
                <div class="rating-bars-item">
                    <span class="rating-bars-name">{{$t('Commitment to deadlines')}}</span>
                    <span class="rating-bars-inner">
                        <span class="rating-bars-rating good" data-rating="3.9">
                            <span class="rating-bars-rating-inner" style="width: 75%;"></span>
                        </span>
                        <strong>3.9</strong>
                    </span>
                </div>
                <div class="rating-bars-item">
                    <span class="rating-bars-name">{{$t('Professionalism and communication')}}</span>
                    <span class="rating-bars-inner">
                        <span class="rating-bars-rating mid" data-rating="3.2">
                            <span class="rating-bars-rating-inner" style="width: 52.2%;"></span>
                        </span>
                        <strong>3.2</strong>
                    </span>
                </div>
                <div class="rating-bars-item">
                    <span class="rating-bars-name">{{$t('Transparency in pricing and costs')}}</span>
                    <span class="rating-bars-inner">
                        <span class="rating-bars-rating poor" data-rating="2.0">
                            <span class="rating-bars-rating-inner" style="width:20%;"></span>
                        </span>
                        <strong>2.0</strong>
                    </span>
                </div>
            </div>
        </div> -->
                        
        <!-- <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link to="" data-bs-toggle="collapse" data-parent="#rev"  data-bs-target="#clEight" aria-controls="clEight" aria-expanded="true"><h4 class="property_block_title">{{$t('Review')}}</h4></router-link>
            </div>
            
            <div id="clEight" class="panel-collapse collapse show">
                <div class="block-body">
                    <div class="author-review">
                        <div class="comment-list">
                            <ul>
                                <li v-for="(item, index) in review" :key="index" class="article_comments_wrap">
                                    <article>
                                        <div class="article_comments_thumb">
                                            <img :src="item.image" alt="">
                                        </div>
                                        <div class="comment-details">
                                            <div class="comment-meta">
                                                <div class="comment-left-meta">
                                                    <h4 class="author-name">{{item.name}}</h4>
                                                    <div class="comment-date">{{item.date}}</div>
                                                </div>
                                            </div>
                                            <div class="comment-text">
                                                <p>{{item.desc}}</p>
                                            </div>
                                        </div>
                                    </article>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <router-link to="" class="reviews-checked text-primary"><i class="fas fa-arrow-alt-circle-down mr-2"></i>See More Reviews</router-link>
                </div>
            </div>
            
        </div> -->
                        
        <div class="property_block_wrap style-2">
        <div class="property_block_wrap_header">
            <router-link
            data-bs-toggle="collapse"
            data-parent="#reviews"
            data-bs-target="#clReviews"
            aria-controls="clReviews"
            to=""
            aria-expanded="true"
            class="collapsed"
            >
            <h4 class="property_block_title">{{ $t("Reviews") }}</h4>
            </router-link>
        </div>

        <div id="clReviews" class="panel-collapse collapse">
            <div class="block-body">
            <div v-if="reviews.length === 0" class="text-center text-muted py-3">
                {{ $t("No reviews yet") }}
            </div>
            <div v-else>
                <div 
                v-for="user in reviews" 
                :key="user.user_id" 
                class="mb-4 p-3 border rounded shadow-sm"
                >
                <h5 class="fw-bold mb-3">
                    <i class="fa fa-user me-2"></i>{{ user.user_name }}
                </h5>

                <div 
                    v-for="review in user.reviews" 
                    :key="review.id" 
                    class="mb-3 border-bottom pb-2"
                >
                    <div class="d-flex justify-content-between align-items-center">
                    <span class="fw-semibold text-capitalize">
                        {{ review.review_point_title }}
                    </span>

                    <div>
                        <i 
                        v-for="star in 5"
                        :key="star"
                        class="fa"
                        :class="star <= Number(review.stars) ? 'fa-star text-warning' : 'fa-star text-secondary opacity-25'"
                        ></i>
                    </div>
                    </div>

                    <p class="mb-0 text-muted small">
                    {{ review.review }}
                    </p>
                </div>
                </div>
            </div>

            </div>
        </div>
        </div>

        
        <div class="property_block_wrap style-2">
            <div class="property_block_wrap_header">
                <router-link data-bs-toggle="collapse" data-parent="#clRev"  data-bs-target="#clRev" aria-controls="clOne" to="" aria-expanded="true" class="collapsed"><h4 class="property_block_title">{{$t('Send a Review')}}</h4></router-link>
            </div>
            <div id="clRev" class="panel-collapse collapse">
                <div class="block-body">
                    <div v-if="errorMessage" class="alert alert-warning text-center">
                        {{ $t(errorMessage) }}
                    </div>

                    <div v-else>
                        <div
                        v-for="point in reviewPoints"
                        :key="point.id"
                        class="mb-3 p-2 border-b cursor-pointer"
                        @click="openModal(point)"
                        >
                        <span class="font-semibold">{{ point.review_points }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal fade"
            tabindex="-1"
            :class="{ show: showModal }"
            style="display: block"
            v-if="showModal"
        >
            <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content p-3 rounded">
                <div class="modal-header">
                <h5 class="modal-title">
                    {{ selectedPoint?.review_points }}
                </h5>
                <button
                    type="button"
                    class="btn-close ms-3"
                    @click="showModal = false"
                ></button>
                </div>

                <div class="modal-body">
                <!-- Star Rating -->
                <div class="flex gap-1 mb-3">
                    <span
                    v-for="star in 5"
                    :key="star"
                    class="cursor-pointer text-2xl"
                    :class="{
                        'text-yellow-500': modalData.stars >= star,
                        'text-gray-300': modalData.stars < star
                    }"
                    @click="handleStarClick(star)"
                    >
                    ★
                    </span>
                </div>

                <!-- Review Text -->
                <textarea
                    v-model="modalData.review"
                    class="form-control mb-3"
                    :placeholder="$t('Message')"
                ></textarea>

                <!-- Multi Image Upload -->
                <input
                    type="file"
                    multiple
                    accept="image/*"
                    class="form-control mb-3"
                    @change="handleImageUpload"
                />
                </div>

                <div class="modal-footer">
                <button
                    class="btn btn-secondary"
                    @click="showModal = false"
                >
                    {{ $t("Close") }}
                </button>
                <button
                    class="btn btn-primary"
                    @click="submitReview"
                >
                    {{ $t("Submit Review") }}
                </button>
                </div>
            </div>
            </div>
        </div>
        <!-- BRANCHES -->
        <div class="property_block_wrap style-2 branches-section">
            <div class="property_block_wrap_header">
                <div class="branch-title">
                    <h4 class="property_block_title">
                        {{ $t('Branches') }}
                    </h4>
                </div>
            </div>
            <div class="block-body">
                <div
                    v-if="branches.length === 0"
                    class="text-muted text-center py-3"
                >
                    {{ $t('No branches available') }}
                </div>
                <div
                    v-else
                    class="branches-wrapper"
                >
                    <ul
                        class="nav nav-tabs branch-tabs mb-4"
                        role="tablist"
                    >
                        <li
                            v-for="(branch, index) in branches"
                            :key="branch.id ?? `branch-${index}`"
                            class="nav-item"
                            role="presentation"
                        >
                            <button
                                type="button"
                                class="nav-link"
                                :class="{
                                    active: activeBranchIndex === index
                                }"
                                @click="activeBranchIndex = index"
                            >
                                {{ getBranchName(branch, index) }}
                            </button>
                        </li>
                    </ul>
                    <div
                        v-if="activeBranch"
                        class="branch-details"
                    >
                        <div
                            v-if="activeBranch.address"
                            class="branch-address mb-4"
                        >
                            <div class="d-flex align-items-start gap-2">
                                <i class="fa-solid fa-location-dot mt-1"></i>
                                <div>
                                    <strong>{{ $t('Address') }}</strong>
                                    <p class="mb-0">
                                        {{ activeBranch.address }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div
                            v-if="hasCoordinates(activeBranch)"
                            class="branch-map-wrapper"
                        >
                            <iframe
                                :src="getGoogleMapUrl(activeBranch)"
                                class="branch-map"
                                frameborder="0"
                                allowfullscreen
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>

                        <div
                            v-else
                            class="text-muted text-center py-4"
                        >
                            {{ $t('Location coordinates are not available') }}
                        </div>

                    </div>

                </div>

            </div>

        </div>

        <div class="modal fade" id="popup-video" tabindex="-1" role="dialog" aria-labelledby="popupvideo" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content" id="popupvideo">
                    <iframe class="embed-responsive-item full-width"  height="480" src="https://www.youtube.com/embed/S_CGed6E610?rel=0" frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted} from 'vue';
// import Multiselect from '@vueform/multiselect';
import '@vueform/multiselect/themes/default.css';
// import pl6 from '@/assets/img/pl-6.jpg'
// import edu from '@/assets/img/edu.png'
// import floor from '@/assets/img/floor.jpg'
// import food from '@/assets/img/food.png'
// import {  review } from '@/data/detail-data';
import axios from 'axios'
import { defineProps,computed } from "vue";
import { useI18n } from 'vue-i18n';
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification"
const toast = useToast()
const { locale } = useI18n();
const { t } = useI18n();
// const { t } = useI18n()
const props = defineProps({
item: {
    type: Object,
    required: true,
}
});

const mapUrl = computed(() => {
const lat = props.item.latitude
const lng = props.item.longitude 
if (lat && lng) {
    return `https://www.google.com/maps?q=${lat},${lng}&hl=en&z=14&output=embed`
}
return ''
})

// const rate = ref([
//     '*',
//     '**',
//     '***',
//     '****',
//     '*****',
//     '******',
// ])

const route = useRoute();
const providerId = route.params.id; 
const reviewPoints = ref([]);
const selectedPoint = ref(null);
const showModal = ref(false);

const modalData = ref({
stars: 0,
review: "",
images: []
});
const errorMessage = ref("");
const fetchReviewsPoint = async () => {
try {
    const token = localStorage.getItem("auth_token");
    const userType = localStorage.getItem('user_type');
    if (!token || userType != 'Customer') {
    errorMessage.value = "You should be logged in and be Customer"; 
    return;
    }

    const response = await axios.get("/get-review-points", {
    headers: {
        Authorization: `Bearer ${token}`,
        locale: locale.value
    }
    });

    reviewPoints.value = response.data.reviewPoints;
} catch (error) {
    console.error("Error fetching review points:", error);
    errorMessage.value = "Failed to load review points";
}
};


const openModal = (point) => {
selectedPoint.value = point;
modalData.value.stars = 0;
modalData.value.review = "";
modalData.value.images = [];
showModal.value = true;
};

const handleStarClick = (rating) => {
modalData.value.stars = rating;
};

const handleImageUpload = (e) => {
modalData.value.images = Array.from(e.target.files);
};

const submitReview = async () => {
try {
    if (modalData.value.stars === 0) {
    toast.error(t("Please select a star rating"));
    return;
    }

    if (!modalData.value.review.trim()) {
    toast.error(t("Please write a review"));
    return;
    }

    if (modalData.value.images.length === 0) {
    toast.error(t("Please upload at least one image"));
    return;
    }

    const token = localStorage.getItem("auth_token");
    const payload = new FormData();

    payload.append("provider_id", providerId);
    payload.append("review_point_id", selectedPoint.value.id);
    payload.append("stars", modalData.value.stars);
    payload.append("review", modalData.value.review);

    modalData.value.images.forEach((img, index) => {
    payload.append(`attachments[${index}]`, img);
    });

    const response = await axios.post("/review/create", payload, {
    headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        locale : locale.value
    }
    });
    toast.success(response.data.msg)
    // alert("Review submitted successfully!");
    showModal.value = false;
} catch (error) {
    console.error("Error submitting review:", error);
}
};
const reviews = ref([]);
const fetchReviews = async () => {
try {
    const response = await axios.get(`/get-reviews/${providerId}`, {
    headers: {
        locale: locale.value
    }
    });

    reviews.value = response.data.users;
    console.log('reviews',reviews.value);
    
} catch (error) {
    console.error("Error fetching reviews:", error);
    errorMessage.value = "Failed to load reviews";
}
};
onMounted(() => {
fetchReviewsPoint();
fetchReviews();
});
/* branches */
const activeBranchIndex = ref(0);

const branches = computed(() => {
    return props.item?.branches || [];
});


const activeBranch = computed(() => {
    return branches.value[activeBranchIndex.value] || null;
});


const getBranchName = (branch, index) => {
    if (branch.type === 'main' && !branch.name) {
        return t('Main');
    }
    if (branch.name) {
        return branch.name;
    }
    return `${t('Branch')} ${index + 1}`;
};

const hasCoordinates = (branch) => {
    if (!branch) {
        return false;
    }

    const lat = Number(branch.latitude);
    const lng = Number(branch.longitude);

    return (
        branch.latitude !== null &&
        branch.latitude !== undefined &&
        branch.latitude !== '' &&
        branch.longitude !== null &&
        branch.longitude !== undefined &&
        branch.longitude !== '' &&
        Number.isFinite(lat) &&
        Number.isFinite(lng) &&
        lat >= -90 &&
        lat <= 90 &&
        lng >= -180 &&
        lng <= 180
    );
};

const getGoogleMapUrl = (branch) => {
    if (!hasCoordinates(branch)) {
        return '';
    }

    const lat = Number(branch.latitude);
    const lng = Number(branch.longitude);

    return `https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`;
};
</script>
<style scoped>
.text-yellow-500 {
color: #facc15;
}
.text-gray-300 {
color: #d1d5db;
}
.modal {
background: rgba(0, 0, 0, 0.4);
}

/* BRANCHES */
.branches-section {
    width: 100%;
}

.branches-wrapper {
    width: 100%;
}

.branch-content {
    width: 100%;
}

.branch-details {
    width: 100%;
}


/* BRANCH TABS */

.branch-tabs {
    width: 100%;
    margin-bottom: 25px;
}

.branch-tabs .nav-item {
    margin-right: 5px;
}

.branch-tabs .nav-link {
    cursor: pointer;
}


/* ADDRESS */

.branch-address {
    width: 100%;
}


/* GOOGLE MAP */

.branch-map-wrapper {
    width: 100%;
    height: 500px;
    min-height: 500px;
    margin-top: 20px;
    position: relative;
    overflow: hidden;
    border-radius: 8px;
}

.branch-map {
    display: block;
    width: 100% !important;
    height: 100% !important;
    min-height: 500px;
    border: 0;
}
</style>